module.exports = __webpack_public_path__ + "static/logo-telis-dark-big-4ca443f9fd0bec66ef7f25fd3881443e.png";